export class CompareItemModel {
  firstItem: string;
  secondItem: string;
  parentDate: Date;
  parentRulebook: string;
  parentTopic: string;
  parentHyperlink: string;

  constructor() {
    this.firstItem = '';
    this.secondItem = '';
    this.parentDate = new Date();
    this.parentRulebook = '';
    this.parentTopic = '';
    this.parentHyperlink = '';
  }
}
